import { CandidateFilterType } from '../../../../common/enums/CandidateFilterType';
import { ICheckboxFilterItem } from '../../../../common/models/filter/ICheckboxFilterItem';
import { DashboardColor } from '../../../../common/enums/DashboardColor';

export const sidebarItems: ICheckboxFilterItem[] = [{
  id: CandidateFilterType.AllActive,
  name: 'candidateSidebarFilter.AllActive',
  count: 0,
  color: DashboardColor.Neutral,
  children: [{
    id: CandidateFilterType.WaitingForCandidate,
    name: 'candidateSidebarFilter.WaitingForCandidate',
    color: DashboardColor.Neutral,
    count: 0
  } as ICheckboxFilterItem,
    {
      id: CandidateFilterType.NoSurveysComplete,
      name: 'candidateSidebarFilter.NoSurveysComplete',
      color: DashboardColor.BrightNeutral,
      count: 0
    } as ICheckboxFilterItem,
    {
      id: CandidateFilterType.OnePlusSurveysComplete,
      name: 'candidateSidebarFilter.OnePlusSurveysComplete',
      color: DashboardColor.Yellow,
      count: 0
    } as ICheckboxFilterItem,
    {
      id: CandidateFilterType.AllSurveysComplete,
      name: 'candidateSidebarFilter.AllSurveysComplete',
      color: DashboardColor.Green,
      count: 0
    } as ICheckboxFilterItem]
} as ICheckboxFilterItem,
  {
    id: CandidateFilterType.AllInactive,
    name: 'candidateSidebarFilter.AllInactive',
    count: 0,
    color: DashboardColor.Neutral,
    children: [{
      id: CandidateFilterType.InactiveHired,
      name: 'candidateSidebarFilter.InactiveHired',
      color: DashboardColor.Blue,
      count: 0
    } as ICheckboxFilterItem,
    {
      id: CandidateFilterType.InactiveHibernate,
      name: 'candidateSidebarFilter.InactiveHibernate',
      color: DashboardColor.Purple,
      count: 0
    } as ICheckboxFilterItem]
  } as ICheckboxFilterItem
];
